import * as React from 'react';
const StarOffIcon = (props: any) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 2L9.34708 6.1459H13.7063L10.1796 8.7082L11.5267 12.8541L8 10.2918L4.47329 12.8541L5.82037 8.7082L2.29366 6.1459H6.65292L8 2Z"
      fill="#E6E6E6"
    />
  </svg>
);
export default StarOffIcon;
